const map = {
	"./3i.png": 6715,
	"./apc.png": 3033,
	"./app_logo.png": 6154,
	"./app_logo_sophia.png": 5567,
	"./att.png": 6490,
	"./bi.png": 7988,
	"./ch_arras.png": 1522,
	"./ch_boulogne.png": 8264,
	"./ch_valenciennes.png": 882,
	"./chu_logo.png": 5315,
	"./chu_montpellier.png": 2205,
	"./chul.png": 5213,
	"./chuv.png": 1687,
	"./clarunis_logo.jpg": 9562,
	"./cnr.png": 7068,
	"./cnrs_logo.png": 4811,
	"./easo.png": 2519,
	"./efpia.jpeg": 9267,
	"./efpia.png": 5890,
	"./egid_logo.png": 2288,
	"./emc.png": 7526,
	"./europe_hdf.png": 1038,
	"./exe.png": 9459,
	"./gwu.png": 5744,
	"./ic_brazil.png": 8158,
	"./ic_france.png": 437,
	"./ic_uk.png": 1152,
	"./idibgi.png": 6221,
	"./imi.png": 4520,
	"./inr_logo_rouge.png": 3649,
	"./inserm_logo.png": 7843,
	"./jdrf.png": 2377,
	"./kul.png": 2787,
	"./lancet_digital_health.png": 1840,
	"./lancet_digital_health_small.png": 5848,
	"./lipo.png": 721,
	"./lly.png": 7434,
	"./logo_cristal.png": 5957,
	"./logo_isite.png": 2859,
	"./logo_univ_lille.png": 3048,
	"./lund.png": 4832,
	"./maccabi.png": 529,
	"./med.png": 89,
	"./met.png": 697,
	"./mu.png": 7865,
	"./ned_obesitas.png": 4091,
	"./novo.png": 6407,
	"./oac.png": 1628,
	"./oswaldo_cruz_logo.png": 651,
	"./pfizer.png": 4253,
	"./sgh.jpeg": 678,
	"./sib.png": 7649,
	"./sophia_logo.png": 7445,
	"./sos_logo.png": 1482,
	"./t1de.png": 7735,
	"./ucd.png": 3251,
	"./ucsc.png": 8413,
	"./udd.png": 1246,
	"./ugot.png": 2050,
	"./uht.png": 3978,
	"./ulm.png": 1959
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6467;